import styled from '@emotion/styled'
import {
    breakpoint,
    BreakpointState,
    breakpointSwitch,
    calcRem,
    getComponentTheme,
    ThemeConfig,
} from '../../__styling'
import { StyledMediaProps } from '../Landscape/Landscape.styled'
import { ImageRatio } from '@news-mono/web-common'
import { CardMedia } from '../CardMedia/CardMedia'
import { EditorialType, FundingType } from '../../templates'
import { tokens } from '@news-mono/design-tokens'
import { CardHeadline } from '../CardText/CardHeadline'

export const StyledHeader = styled.div({
    display: 'flex',
    flexDirection: 'column',
    flexWrap: 'wrap',
    alignSelf: 'stretch',
    flex: `1 2 ${calcRem(120)}`,
})
StyledHeader.displayName = 'LandscapeHeaderWrapper'

export const StyledLandscapeNumber = styled.div(({ theme }) => {
    const iconTheme = getComponentTheme(theme, 'landscape').number
    return [
        {
            color: iconTheme.color,
            fontWeight: 400,
            paddingRight: calcRem(16),
            lineHeight: '105%',
        },
        breakpointSwitch(iconTheme.breakpointState, ({ fontSize }) => ({
            fontSize,
        })),
    ]
})

export const StyledHeadline = styled(CardHeadline)({
    margin: 0,
    width: '100%',
    flex: 'none', // overide default headline flexbox from CardText component
    fontSize: calcRem(16),
    fontWeight: 600,
    lineHeight: '150%',

    [breakpoint('sm')]: {
        fontSize: calcRem(18),
    },
    [breakpoint('md')]: {
        lineHeight: calcRem(28),
        fontSize: calcRem(20),
    },
})
StyledHeadline.displayName = 'LandscapeHeadline'

export const StyledClassificationLabel = styled.span<{
    type: EditorialType | FundingType
}>(({ theme, type }) => ({
    textTransform: 'uppercase',
    font: theme.fonts.sansSerif,
    fontSize: calcRem(12),
    fontWeight: 600,
    lineHeight: '133%',
    color:
        type === EditorialType.Breaking ||
        type === EditorialType.Live ||
        type === EditorialType.Exclusive
            ? tokens.thenightly.colors.palette.utility.error.default
            : undefined,
}))

export interface StyledNightlyMediaProps extends StyledMediaProps {
    CSSCrop: BreakpointState<ThemeConfig, ImageRatio>
    numbered: boolean
}

export const StyledNightlyMedia = styled(CardMedia)<StyledNightlyMediaProps>(
    ({ imagePosition, theme, imageWidths, CSSCrop, numbered }) => ({
        width: imageWidths.mobile,
        //height: getImageHeight(CSSCrop, imageWidths.mobile),
        margin:
            imagePosition === 'right'
                ? `0 0 0 ${calcRem(theme.margins.sm)}`
                : `0 ${calcRem(theme.margins.sm)} 0 0`,

        [breakpoint('sm')]: {
            width: imageWidths.tablet,
            //height: getImageHeight(CSSCrop, imageWidths.tablet),
        },
        [breakpoint('lg')]: {
            width: imageWidths.desktop,
            //height: getImageHeight(CSSCrop, imageWidths.desktop),
            display: numbered ? 'none' : undefined,
        },
    }),
)

function getImageHeight(ratio: ImageRatio, width: string) {
    return (parseInt(width, 10) / ratio.width) * ratio.height
}
